import React from "react";
import theme from "../../themes/theme";

interface Props {
  count: number | undefined;
}

const pillStyle: React.CSSProperties = {
  display: "inline-block",
  minWidth: 18,
  marginLeft: 8,
  padding: "1px 6px",
  borderRadius: 4,
  backgroundColor: theme.colors.teal["1"],
  color: "#FFFFFF",
  fontSize: 11,
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  verticalAlign: "middle",
};

// Active-record count after a project-nav item, like the legacy sidebar badge.
// Hidden at zero: the pill marks areas that have content.
const NavCountPill = ({ count }: Props) => {
  if (!count || count <= 0) return null;

  return (
    <span data-testid="nav-count-pill" aria-hidden="true" style={pillStyle}>
      {count}
    </span>
  );
};

export default NavCountPill;
